module.exports = __webpack_public_path__ + "static/img/grade_16.ead141a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_16.png
// module id = 7/h6
// module chunks = 89